/* eslint-disable */
require('./excellent')
require('./good')
require('./great')
require('./poor')
